import React, { createContext, useState, useEffect, useContext, useMemo } from 'react'
import { useCauses } from '@context/CausesContext/CausesContext'
import { getOurCauses } from '@services/CausesService'
import { Cause } from '@Interfaces/Data/CauseInterface'
import { User } from '@Interfaces/Data/UserInterface'
import { Skill } from '@Interfaces/Data/SkillInterface'
import { UserContextProps, UserContextDefaultValues } from '@Interfaces/Data/UserInterface'
import { ContextComponentProps } from '@Interfaces/Util/CommonInterface'

export const UserContext = createContext<UserContextProps>(UserContextDefaultValues)

export const UserProvider = ({ children }: ContextComponentProps) => {
  const { allCauses } = useCauses()
  const [selectedUser, setSelectedUser] = useState<User | null>(null)
  const [causes, setCauses] = useState<Cause[] | null>(null)
  const [skills] = useState<Skill[] | null>(null)

  //set selected user causes
  useEffect(() => {
    if (!selectedUser || !allCauses || allCauses.length === 0) return
    const causeIds = selectedUser.causes || []
    const filtered = getOurCauses(causeIds, allCauses)
    setCauses(filtered)
  }, [selectedUser?.id, allCauses.length])

  const contextValue = useMemo(
    () => ({
      selectedUser,
      setSelectedUser,
      causes,
      skills,
    }),
    [selectedUser, causes, skills]
  )

  return <UserContext.Provider value={contextValue}>{children}</UserContext.Provider>
}

export const useUsers = (): UserContextProps => useContext(UserContext)
